import { CheckboxField, Flex, Text, TextAreaField } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { PANEL_MESSAGES } from "./message-definitions";

interface CannotProvideStatementsProps {
  label: string;
  visible: boolean;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  note: string;
  onNoteChange: (note: string) => void;
  requiredMonths: number;
}

export const CannotProvideStatements = ({
  label,
  visible,
  checked,
  onCheckedChange,
  note,
  onNoteChange,
  requiredMonths,
}: CannotProvideStatementsProps) => {
  const intl = useIntl();

  if (!visible) {
    return null;
  }

  return (
    <Flex direction="column" gap="4">
      <Flex direction="column" gap="2">
        <CheckboxField
          name="bank-statement-air-cannot-provide"
          options={{
            name: "bank-statement-air-cannot-provide",
            label: <Text size="sm">{label}</Text>,
            checked,
            onChange: onCheckedChange,
          }}
        />
        {checked && (
          <Text size="xs" color="subtle">
            {intl.formatMessage(PANEL_MESSAGES.cannotProvideConsequence, { months: requiredMonths })}
          </Text>
        )}
      </Flex>
      {checked && (
        <TextAreaField
          name="bank-statement-air-cannot-provide-note"
          label={intl.formatMessage(PANEL_MESSAGES.cannotProvideNoteLabel)}
          optional
          value={note}
          onChange={(event) => onNoteChange(event.target.value)}
        />
      )}
    </Flex>
  );
};
